"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ColorOption = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../constants");
var _styles = require("../styles");
var _BaseOption = require("./BaseOption");
var _jsxRuntime = require("react/jsx-runtime");
const ColorOption = (param)=>{
    let { selected, hexColors, label, onClick, onDelete, LabelProps, OptionProps } = param;
    const labelProps = {
        fontWeight: selected ? 'bold' : 'regular',
        ...LabelProps
    };
    const { getTestId } = (0, _testidGenerator.default)();
    const icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Color, {
        "data-testid": getTestId(_constants.COLOR_OPTION_ICON),
        selected: selected,
        hexColors: hexColors,
        selectedIconSize: OptionProps === null || OptionProps === void 0 ? void 0 : OptionProps.selectedIconSize,
        iconSize: OptionProps === null || OptionProps === void 0 ? void 0 : OptionProps.iconSize
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_BaseOption.BaseOption, {
        variant: "rounded",
        label: label,
        LabelProps: labelProps,
        height: OptionProps === null || OptionProps === void 0 ? void 0 : OptionProps.height,
        icon: icon,
        onClick: onClick,
        onDelete: onDelete
    });
};
exports.ColorOption = ColorOption;
